export const communityActionAgenciesLink =
"https://www.scanaenergyregulated.com/about-the-program/community-action-agencies";